import { render, staticRenderFns } from "./modalViewFechamento.vue?vue&type=template&id=31b63432&scoped=true"
import script from "./modalViewFechamento.vue?vue&type=script&lang=js"
export * from "./modalViewFechamento.vue?vue&type=script&lang=js"
import style0 from "./modalViewFechamento.vue?vue&type=style&index=0&id=31b63432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b63432",
  null
  
)

export default component.exports